import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance } from 'intact-vue-next';
import { watchState } from '../../hooks/useState';
import { toggleArray } from '../utils';
import { useReceive } from '../../hooks/useReceive';
export var AllCheckedStatus;
(function (AllCheckedStatus) {
  AllCheckedStatus[AllCheckedStatus["All"] = 0] = "All";
  AllCheckedStatus[AllCheckedStatus["Indeterminate"] = 1] = "Indeterminate";
  AllCheckedStatus[AllCheckedStatus["None"] = 2] = "None";
})(AllCheckedStatus || (AllCheckedStatus = {}));
export function useChecked(getEnableKeys, getAllKeys, isDisabledKey, getGrid, loopData, data) {
  var instance = useInstance();
  var allStatus = [];
  function isChecked(key) {
    return inArray(instance.get('checkedKeys'), key);
  }
  function toggleChecked(key, rowIndex) {
    if (instance.get('checkType') === 'checkbox') {
      instance.set('checkedKeys', toggleArray(instance.get('checkedKeys'), key));
      // trigger check event for checkbox,
      // radio check event trigger in onChangeChecked function
      triggerEvent(isChecked(key), key, rowIndex);
    } else {
      if (isChecked(key)) return;
      var grid = getGrid();
      var gridRow = grid[rowIndex];
      if (gridRow) {
        // find the row index that has grouped radio
        while (!grid[rowIndex][0].render) {
          rowIndex--;
        }
      }
      onChangeChecked(rowIndex, true, key);
    }
  }
  function getAllCheckedStatus() {
    var _instance$get = instance.get(),
      checkedKeys = _instance$get.checkedKeys;
    var enabledKeys = getEnableKeys();
    if (enabledKeys.length && checkedKeys) {
      if (enabledKeys.every(function (key) {
        return _includesInstanceProperty(checkedKeys).call(checkedKeys, key);
      })) {
        return AllCheckedStatus.All;
      } else if (enabledKeys.some(function (key) {
        return _includesInstanceProperty(checkedKeys).call(checkedKeys, key);
      })) {
        return AllCheckedStatus.Indeterminate;
      }
    }
    return AllCheckedStatus.None;
  }
  function toggleCheckedAll(v) {
    instance.set('checkedKeys', getCheckedAllOrUncheckedAllKeys(v));
    instance.trigger(v ? 'checkAll' : 'uncheckAll');
  }
  /**
   * keep the original keys which don't exist in the enableKeys,
   * and add or remove the enableKeys
   */
  function getCheckedAllOrUncheckedAllKeys(isChecked) {
    var checkedKeys = instance.get('checkedKeys');
    var enabledKeys = getEnableKeys();
    if (!checkedKeys) {
      if (isChecked) {
        return _sliceInstanceProperty(enabledKeys).call(enabledKeys);
      } else {
        return [];
      }
    }
    var results = _sliceInstanceProperty(checkedKeys).call(checkedKeys);
    enabledKeys.forEach(function (key) {
      addOrRemove(results, key, isChecked);
    });
    return results;
  }
  function updateAllCheckedStatus() {
    allStatus = [];
    var _instance$get2 = instance.get(),
      rowKey = _instance$get2.rowKey,
      checkType = _instance$get2.checkType,
      merge = _instance$get2.merge;
    if (!data.value || !data.value.length) return;
    var allKeys = getAllKeys();
    allKeys.forEach(function (key) {
      var disabled = isDisabledKey(key);
      allStatus.push({
        checked: isChecked(key),
        indeterminate: false,
        disabled: disabled,
        allDisabled: disabled
      });
    });
    var grid = getGrid();
    if (merge && checkType !== 'none') {
      loopData(function (data, rowIndex) {
        var _grid$rowIndex$ = grid[rowIndex][0],
          spans = _grid$rowIndex$.spans,
          render = _grid$rowIndex$.render;
        var rowspan;
        if (render && spans && (rowspan = spans.rowspan) > 1) {
          var enabledCheckedCount = 0;
          var disabledCheckedCount = 0;
          var disabledCount = 0;
          for (var i = rowIndex; i < rowspan + rowIndex; i++) {
            var _status = allStatus[i];
            if (isDisabledKey(allKeys[i])) {
              disabledCount++;
              if (_status.checked) {
                disabledCheckedCount++;
              }
            } else if (_status.checked) {
              enabledCheckedCount++;
            }
          }
          var status = allStatus[rowIndex];
          if (disabledCount === rowspan) {
            // all rows are disabled
            status.allDisabled = true;
            if (disabledCheckedCount === rowspan) {
              status.checked = true;
            } else if (disabledCheckedCount > 0) {
              status.indeterminate = true;
            }
          } else {
            status.allDisabled = false;
            if (enabledCheckedCount + disabledCount === rowspan) {
              status.checked = true;
            } else if (enabledCheckedCount > 0) {
              status.indeterminate = true;
            }
          }
        }
      });
      // console.log(allStatus);
    }
  }
  function onChangeChecked(rowIndex, v, key) {
    var _context;
    // should check or uncheck all grouped rows
    var checkType = instance.get('checkType');
    var checkedKeys = _sliceInstanceProperty(_context = instance.get('checkedKeys') || []).call(_context);
    // if is radio check, remove all enabled keys
    if (checkType === 'radio') {
      for (var i = 0; i < checkedKeys.length; i++) {
        var _key = checkedKeys[i];
        // FIXME: should ignore the disabled status, if we remove the radio keys
        if (isDisabledKey(_key)) continue;
        _spliceInstanceProperty(checkedKeys).call(checkedKeys, i, 1);
        i--;
      }
    }
    var grid = getGrid();
    var allKeys = getAllKeys();
    var rowspan;
    if ((rowspan = grid[rowIndex]) && (rowspan = rowspan[0]) && (rowspan = rowspan.spans) && (rowspan = rowspan.rowspan) && rowspan > 1) {
      for (var _i = rowIndex; _i < rowspan + rowIndex; _i++) {
        var status = allStatus[_i];
        var _key2 = allKeys[_i];
        if (!status.disabled) {
          addOrRemove(checkedKeys, _key2, v);
        }
      }
    } else {
      addOrRemove(checkedKeys, allKeys[rowIndex], v);
    }
    instance.set('checkedKeys', checkedKeys);
    // onChangeChecked will be called in clickRow and check in Row component
    triggerEvent(v, key, rowIndex);
  }
  function getAllStatus() {
    return allStatus;
  }
  function triggerEvent(isChecked, key, rowIndex) {
    instance.trigger(isChecked ? 'checkRow' : 'uncheckRow', data.value[rowIndex], rowIndex, key);
  }
  // instance.on('$receive:children', updateAllCheckedStatus);
  useReceive(['children'], updateAllCheckedStatus);
  instance.on('$change:checkedKeys', updateAllCheckedStatus);
  // for draggable
  watchState(data, updateAllCheckedStatus);
  // instance.on('$change:data', updateAllCheckedStatus);
  instance.on('clickRow', function (data, index, key) {
    if (instance.get('rowCheckable') && instance.get('checkType') !== 'none') {
      toggleChecked(key, index);
    }
  });
  return {
    isChecked: isChecked,
    getAllCheckedStatus: getAllCheckedStatus,
    toggleCheckedAll: toggleCheckedAll,
    getAllStatus: getAllStatus,
    onChangeChecked: onChangeChecked
  };
}
export function inArray(arr, v) {
  if (!arr) return false;
  return arr.indexOf(v) > -1;
}
export function addOrRemove(keys, key, isAdd) {
  var index = keys.indexOf(key);
  if (isAdd) {
    if (index === -1) {
      keys.push(key);
    }
  } else if (index > -1) {
    _spliceInstanceProperty(keys).call(keys, index, 1);
  }
}